import styled from '@emotion/styled';
import Skeleton from '@material-ui/lab/Skeleton';
import { Spacings, mediaQuery } from '@styles/index';

// eslint-disable-next-line react/jsx-props-no-spreading
const RectSkeleton = (props) => <Skeleton variant="rect" {...props} />;

const Button = styled(RectSkeleton)`
  width: 50%;
  height: ${Spacings.SPACING_12B};

  ${mediaQuery.uptoMobile} {
    width: 100%;
    height: ${Spacings.SPACING_12B};
  }
`;

const Actions = () => <Button />;

export default Actions;
